import { MimeType } from 'vet-bones/constants';

import { databasesStardogRequestDispatchers } from 'src/actions/databases/actionCreators';
import { DatabasesActionType } from 'src/actions/databases/actionTypes';
import { PublishProjectResponse } from 'src/actions/projects/actionCreators';
import { Database } from 'src/store/state/databases';
import { Project } from 'src/store/state/projects';
import * as copy from 'src/templates/copy';
import { getAllProjectNamespaces } from 'src/utils/export/namespaces';
import { stringifyTurtleNamespaces } from 'src/utils/stringify/namespaces';

export const publishNamespaces = async (
  database: Database,
  project: Project,
  extraNamespaces: Record<string, string> = {}
): Promise<PublishProjectResponse> => {
  const namespaces = {
    ...getAllProjectNamespaces(project),
    ...(database.namespaces || {}),
    ...extraNamespaces,
  };
  const contents = stringifyTurtleNamespaces(namespaces);

  const importNamespacesResponse =
    await databasesStardogRequestDispatchers.importDatabaseNamespaces({
      databaseId: database.id,
      contents,
      mimeType: MimeType.TURTLE,
    });

  if (
    importNamespacesResponse.type ===
    DatabasesActionType.IMPORT_DATABASE_NAMESPACES_FAILURE
  ) {
    return {
      success: false,
      action: importNamespacesResponse,
      actionDescription: copy.notifications.database.importNamespaces,
      message: copy.notifications.publishProject.namespaces.failure,
    };
  }

  return {
    success: true,
    action: importNamespacesResponse,
    message: copy.notifications.publishProject.namespaces.success,
  };
};
